import actions from '../../actionTypes';

export default category => {
  return {
    type: actions.EDITED_CATEGORY,
    category
  };
};



// WEBPACK FOOTER //
// ./src/reducers/categories/actions/editedCategory.js